class AxiosCustomError extends Error {
  name
  response
  code

  constructor(
    response,
    message = 'Invalid response type',
    code = 'invalid_response'
  ) {
    super(message)

    this.response = { ...response, ...{ status: 500 } }
    this.name = 'AxiosCustomError'
    this.code = code
  }
}

export default AxiosCustomError
